import { gql } from '@apollo/client'

import type { Squad } from '@/utils/squad'

export type QueryVars = {
  customerId: string
  squad?: Squad
}

export type TotalBySquadStat = {
  all: number
  a: number
  b: number
  c: number
  d: number
  e: number
  f: number
  g: number
  h: number
  i: number
  j: number
  k: number
  l: number
  m: number
  n: number
  other: number
}

export type QueueStatsResponse = {
  totalInventoryBySquad: TotalBySquadStat
  totalEscalatedBySquad: TotalBySquadStat
  totalAddedToInventoryBySquad: TotalBySquadStat
  totalRemovedFromInventoryBySquad: TotalBySquadStat
  totalRemovedFromInventoryBySMEsBySquad: TotalBySquadStat
  totalMissedSLALastWorkingDayBySquad: TotalBySquadStat
  totalMissedSLATwoDaysInARowBySquad: TotalBySquadStat
  totalAutoPassedBySquad: TotalBySquadStat
  totalEscalated: number
  totalUnassigned: number
  totalAssigned: number
  totalChased: number
  totalReopened: number
  totalOver60Hours: number
}

export type Response = {
  getQueueStats: QueueStatsResponse
}

const query = gql`
  query ($customerId: String!, $squad: Squad) {
    getQueueStats(customerId: $customerId, squad: $squad) {
      totalInventoryBySquad {
        all
        a
        b
        c
        d
        e
        f
        g
        h
        i
        j
        k
        l
        m
        n
        other
      }
      totalEscalatedBySquad {
        all
        a
        b
        c
        d
        e
        f
        g
        h
        i
        j
        k
        l
        m
        n
        other
      }
      totalAddedToInventoryBySquad {
        all
        a
        b
        c
        d
        e
        f
        g
        h
        i
        j
        k
        l
        m
        n
        other
      }
      totalRemovedFromInventoryBySquad {
        all
        a
        b
        c
        d
        e
        f
        g
        h
        i
        j
        k
        l
        m
        n
        other
      }
      totalRemovedFromInventoryBySMEsBySquad {
        all
        a
        b
        c
        d
        e
        f
        g
        h
        i
        j
        k
        l
        m
        n
        other
      }
      totalMissedSLALastWorkingDayBySquad {
        all
        a
        b
        c
        d
        e
        f
        g
        h
        i
        j
        k
        l
        m
        n
        other
      }
      totalMissedSLATwoDaysInARowBySquad {
        all
        a
        b
        c
        d
        e
        f
        g
        h
        i
        j
        k
        l
        m
        n
        other
      }
      totalAutoPassedBySquad {
        all
        a
        b
        c
        d
        e
        f
        g
        h
        i
        j
        k
        l
        m
        n
        other
      }
      totalEscalated
      totalUnassigned
      totalAssigned
      totalChased
      totalReopened
      totalOver60Hours
    }
  }
`

export default query
